<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card class="pa-3">

      <v-card-title class="d-flex align-center justify-center">
        <v-icon color="green" large class="mr-2">mdi-check-circle</v-icon>
        <span class="text-h6 font-weight-bold">Pago exitoso</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-list dense>

          <!-- ESTADO -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <strong>Estado:</strong>
                <span class="green--text font-weight-bold">
                  {{ pago?.payment_status === 'paid' ? 'PAGADO' : 'PENDIENTE' }}
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- TOTAL PAGADO -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <strong>Total pagado:</strong>
                ${{ (pago?.amount / 100).toFixed(2) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- ID DEL PAGO -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <strong>ID del Pago:</strong> {{ pago?.id }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- NOMBRE -->
          <v-list-item v-if="pago?.customer_info?.name">
            <v-list-item-content>
              <v-list-item-title>
                <strong>Nombre:</strong> {{ pago.customer_info.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- CORREO -->
          <v-list-item v-if="pago?.customer_info?.email">
            <v-list-item-content>
              <v-list-item-title>
                <strong>Correo:</strong> {{ pago.customer_info.email }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list>

        <v-divider class="my-3"></v-divider>

          Su pago se aplicó correctamente.  
          Su recibo fue enviado al <strong>correo proporcionado</strong>.  
          También puede consultarlo desde su perfil.
   
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn block color="primary" @click="cerrar">
          Cerrar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    pago: {
      type: Object,
      required: true
    }
  },
  data () {
    return { dialog: true }
  },
  methods: {
    cerrar() {
      this.dialog = false
    }
  }
}
</script>
